// router/routes.js
import Layout from '@/layout/index'

// 静态路由（不需要权限，所有用户可见）
export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '',
        name: 'DashboardRedirect',
        component: () => import('@/views/dashboard/index'),
        meta: {
          title: '仪表盘',
          icon: 'el-icon-s-data',
          roles: [0, 1]  // 所有角色都能访问
        }
      }
    ]
  },
  // 404 页面组件定义（不直接添加到路由表）
  {
    path: '/404',
    component: () => import('@/views/error-page/404'),
    hidden: true
  }
]

// 404 路由（单独定义，在动态路由之后添加）
export const notFoundRoute = {
  path: '*',
  redirect: '/404',
  hidden: true
}

// 组件映射表 - 使用更可靠的方式
export const componentMap = {
  // Layout 组件
  'Layout': Layout,
  'layout/index': Layout,
  '@/layout/index': Layout,
  
  // 视图组件
  'Dashboard': () => import('@/views/dashboard/index'),
  'TgUserList': () => import('@/views/tguser/list'),
  'TggroupList': () => import('@/views/tggroup/list'),
  'TgconfigList': () => import('@/views/tgconfig/list'),
  'BotList': () => import('@/views/tgbot/list'),
  'AdminList': () => import('@/views/admin/list'),
  'TgRechargeOrderList': () => import('@/views/tgrechargeorder/list'),
  'TgWithdrawalOrderList': () => import('@/views/tgwithdrawalorder/list'),
  'TgVideoListList': () => import('@/views/tgVideoList/list'),
  
  // 备用：路径映射
  '@/views/dashboard/index': () => import('@/views/dashboard/index'),
  '@/views/tguser/list': () => import('@/views/tguser/list'),
  '@/views/tggroup/list': () => import('@/views/tggroup/list'),
  '@/views/tgconfig/list': () => import('@/views/tgconfig/list'),
  '@/views/admin/list': () => import('@/views/admin/list'),
  '@/views/tgbot/list': () => import('@/views/tgbot/list'),
  '@/views/tgrechargeorder/list': () => import('@/views/tgrechargeorder/list'),
  '@/views/tgwithdrawalorder/list': () => import('@/views/tgwithdrawalorder/list'),
  '@/views/error-page/404': () => import('@/views/error-page/404'),
}

// 动态路由结构 - 优化为更标准的格式
export const defaultAsyncRoutes = [
  {
    path: '/tguser',
    component: 'Layout',  // 改为 'Layout' 而不是 'layout/index'
    redirect: '/tguser/list',
    name: 'TgUser',
    meta: {
      title: '用户管理',
      icon: 'el-icon-user',
      roles: [0,1],
      alwaysShow: true
    },
    children: [
      {
        path: 'list',
        name: 'TgUserList',  // 确保 name 与组件映射一致
        component: 'TgUserList',  // 改为组件名而不是路径
        meta: {
          title: '用户列表',
          roles: [0,1]
        }
      }
    ]
  },
  {
    path: '/tggroup',
    component: 'Layout',
    redirect: '/tggroup/list',
    name: 'Group',
    meta: {
      title: '群组管理',
      icon: 'el-icon-s-tools',
      roles: [0, 1],
      alwaysShow: true
    },
    children: [
      {
        path: 'list',
        name: 'TggroupList',
        component: 'TggroupList',
        meta: {
          title: '群组列表',
          roles: [0, 1]
        }
      }
    ]
  },
  {
    path: '/tgconfig',
    component: 'Layout',
    redirect: '/tgconfig/list',
    name: 'Tgconfig',
    meta: {
      title: '配置管理',
      icon: 'el-icon-s-finance',
      roles: [0, 1],
      alwaysShow: true
    },
    children: [
      {
        path: 'list',
        name: 'TgconfigList',
        component: 'TgconfigList',
        meta: {
          title: '配置列表',
          roles: [0, 1]
        }
      }
    ]
  },
    

  {
    path: '/tgbot',
    component: 'Layout',
    redirect: '/tgbot/list',
    name: 'TgBot',
    meta: {
      title: '机器人管理',
      icon: 'el-icon-s-platform',
      roles: [0],
      alwaysShow: true
    },
    children: [
      {
        path: 'list',
        name: 'BotList',
        component: 'BotList',   
        meta: {
          title: '机器人列表',
          roles: [0, 1]
        }
      }
    ]
  },
  {
    path: '/admin',
    component: 'Layout',
    redirect: '/admin/list',
    name: 'Admin',
    meta: {
      title: '管理员管理',
      icon: 'el-icon-s-finance',
      roles: [0],
      alwaysShow: true
    },
    children: [
      {
        path: 'list',
        name: 'AdminList',
        component: 'AdminList',
        meta: {
          title: '管理员列表',
          roles: [0]
        }
      }
    ]
  },


  {
    path: '/tgVideoList',
    component: 'Layout',
    redirect: '/tgVideoList/list',
    name: 'TgVideoList',
    meta: {
      title: '视频记录管理',
      icon: 'el-icon-video-camera',
      roles: [0, 1],
      alwaysShow: true
    },
    children: [
      {
        path: 'list',
        name: 'TgVideoListList',
        component: 'TgVideoListList',
        meta: {
          title: '视频记录列表',
          roles: [0, 1]
        }
      }
    ]
  },

  //  {
  //   path: '/TgRechargeOrderList',
  //   component: 'Layout',
  //   redirect: '/TgRechargeOrderList/list',
  //   name: 'TgRechargeOrderList',
  //   meta: {
  //     title: '充值订单管理',
  //     icon: 'el-icon-s-finance',
  //     roles: [0],
  //     alwaysShow: true
  //   },
  //   children: [
  //     {
  //       path: 'list',
  //       name: 'TgRechargeOrderList',
  //       component: 'TgRechargeOrderList',
  //       meta: {
  //         title: '充值订单列表',
  //         roles: [0, 1]
  //       }
  //     }
  //   ]
  // },

  //  {
  //   path: '/TgWithdrawalOrderList',
  //   component: 'Layout',
  //   redirect: '/TgWithdrawalOrderList/list',
  //   name: 'TgWithdrawalOrderList',
  //   meta: {
  //     title: '提现订单管理',
  //     icon: 'el-icon-s-finance',
  //     roles: [0],
  //     alwaysShow: true
  //   },
  //   children: [
  //     {
  //       path: 'list',
  //       name: 'TgWithdrawalOrderList',
  //       component: 'TgWithdrawalOrderList',
  //       meta: {
  //         title: '提现订单列表',
  //         roles: [0, 1]
  //       }
  //     }
  //   ]
  // }
]

// 辅助函数：标准化路由配置
export function normalizeRoutes(routes) {
  return routes.map(route => {
    const normalized = { ...route }
    
    // 标准化 component
    if (normalized.component === 'Layout' || normalized.component === 'layout/index') {
      normalized.component = Layout
    }
    
    // 处理子路由
    if (normalized.children && normalized.children.length > 0) {
      normalized.children = normalizeRoutes(normalized.children)
    }
    
    return normalized
  })
}

// 获取所有路由路径（用于权限检查）
export function getAllRoutePaths(routes) {
  const paths = []
  
  function collectPaths(routeList, parentPath = '') {
    routeList.forEach(route => {
      // 排除特殊路径
      if (route.path && route.path !== '*' && !route.path.includes('404')) {
        const fullPath = parentPath 
          ? `${parentPath}/${route.path}`.replace(/\/\//g, '/')
          : route.path
        paths.push(fullPath)
      }
      
      if (route.children) {
        collectPaths(route.children, route.path)
      }
    })
  }
  
  collectPaths(routes)
  return [...new Set(paths)]
}

// 检查路由是否存在
export function routeExists(path, routes) {
  const allPaths = getAllRoutePaths(routes)
  return allPaths.some(routePath => routePath === path || routePath === `/${path}`)
}

// 路由工具函数
export const routeUtils = {
  isExternal,
  resolvePath
}

// 从其他文件导入的工具函数
function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

function resolvePath(basePath, routePath) {
  if (isExternal(routePath)) return routePath
  if (isExternal(basePath)) return basePath
  
  if (basePath && !routePath.startsWith('/')) {
    const cleanBase = basePath.endsWith('/') ? basePath.slice(0, -1) : basePath
    const cleanRoute = routePath.startsWith('/') ? routePath.slice(1) : routePath
    return `${cleanBase}/${cleanRoute}`
  }
  
  return routePath
}
